export default __webpack_public_path__ + "static/media/coming-soon-bg.ad76ca80.jpg";